module.exports = __webpack_public_path__ + "static/media/tec.e6a1bd6f.png";